import { Paper, Stack } from '@mui/material';
import { useCallback } from 'react';
import DropArea from './DropArea';

const Upload = ({onUpload=null, compact=false, children}) => {

  const uploadCallback = useCallback((files) => {
    let file = files[0]
    const reader = new FileReader()
    reader.onabort = () => console.log('file reading was aborted')
    reader.onerror = () => console.log('file reading has failed')
    reader.onload = () => {
        const binaryStr = reader.result
        onUpload({data: binaryStr, filename: file.name.split(".")[0]})
    }
    reader.readAsArrayBuffer(file)
  }, [onUpload])

  const droparea = <DropArea fileHandler={uploadCallback} compact={compact} children={children}/>;
  if (compact) {
    return droparea;
  }

  return <>
  <Paper style={{padding: compact ? 0 : 8}} elevation={0}>
  <Stack spacing={1}>
    {droparea}
  </Stack>
  </Paper>
  </>
}

export default Upload;